import React, { useState, useEffect } from 'react';
import {useStyles} from "./styles/AddGroupStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
    IconButton,
    Dialog
} from "@material-ui/core";
import 'react-datepicker/dist/react-datepicker.css';
import clsx from "clsx";
import { ReactComponent as DialogCloseIcon } from '../../../common/images/DialogCloseIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {COMMON_UTIL} from "../../../common/util/common.util";


const DialogType = {
    email: 'defaultEmail',
    password: 'defaultPassword',
    regionApiAddr: 'regionApiAddr'
};

function GroupDialog(props) {
    const classes = useStyles();
    const {groupStore} = props;
    const {intl} = props;

    const [defaultEmail, setDefaultEmail] = useState('');
    const [defaultPassword, setDefaultPassword] = useState('');
    const [regionApiAddr, setRegionApiAddr] = useState('');

    useEffect(() => {
        let defaultEmail = isAddGroup() ? groupStore.newGroup.defaultEmail : groupStore.modifyGroup.defaultEmail;
        let defaultPassword = isAddGroup() ? groupStore.newGroup.defaultPassword : groupStore.modifyGroup.defaultPassword;
        let defaultRegionApiAddr = isAddGroup() ? groupStore.newGroup.regionApiAddr : groupStore.modifyGroup.regionApiAddr;

        setDefaultEmail(defaultEmail);
        setDefaultPassword(defaultPassword);
        setRegionApiAddr(defaultRegionApiAddr);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupStore.newGroup, groupStore.modifyGroup]);

    const handleClose = () => {
        const defaultEmail = isAddGroup() ? groupStore.newGroup.defaultEmail : groupStore.modifyGroup.defaultEmail;
        const defaultPassword = isAddGroup() ? groupStore.newGroup.defaultPassword : groupStore.modifyGroup.defaultPassword;
        const regionApiAddr = isAddGroup() ? groupStore.newGroup.regionApiAddr : groupStore.modifyGroup.regionApiAddr;
        setDefaultEmail(defaultEmail);
        setDefaultPassword(defaultPassword);
        setRegionApiAddr(regionApiAddr);

        groupStore.setDialogOpen(false);
    }

    const handleChangeGroup = () => {
        let group = Object.assign({}, isAddGroup() ? groupStore.newGroup : groupStore.modifyGroup);
        let value;
        if (DialogType[groupStore.dialogType] === DialogType.email) {
            value = defaultEmail;
        } else if (DialogType[groupStore.dialogType] === DialogType.password) {
            value = defaultPassword;
        } else if (DialogType[groupStore.dialogType] === DialogType.regionApiAddr) {
            value = regionApiAddr;
        } else {
            return null;
        }

        group[DialogType[groupStore.dialogType]] = value;
        if (isAddGroup()) {
            groupStore.setNewGroup(group);
        } else {
            groupStore.setModifyGroup(group);
        }

        groupStore.setDialogOpen(false);
    }

    const isAddGroup = () => {
        return COMMON_UTIL.getUrlPath().includes('add');
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={groupStore.dialogOpen} className={classes.dialogWrap}>
            {groupStore.dialogType === 'email' &&
                <>
                    <Box className={classes.titleDialog} style={{marginBottom: 10}} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography>{intl.formatMessage({id: "group_default_email"})}</Typography>
                        <IconButton className={classes.iconButton} onClick={handleClose} disableRipple>
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                    <Box className={classes.subDialog}>
                        <Typography>{intl.formatMessage({id: "msg_info_group_default_email"})}</Typography>
                    </Box>

                    <Box className={classes.inputBox}>
                        <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "msg_info_group_default_email_rule"})} value={defaultEmail} onChange={(e) => setDefaultEmail(e.target.value)}/>
                    </Box>
                    <Box className={classes.groupBtn}>
                        <Button className={clsx(classes.inputButton, classes.inputButtonActive)} disableRipple onClick={handleChangeGroup}>
                            <Typography>{intl.formatMessage({id: "input"})}</Typography>
                        </Button>
                    </Box>
                </>
            }
            {groupStore.dialogType === 'password' &&
                <>
                    <Box className={classes.titleDialog} style={{marginBottom: 10}} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography>{intl.formatMessage({id: "group_default_password"})}</Typography>
                        <IconButton className={classes.iconButton} onClick={handleClose} disableRipple>
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                    <Box className={classes.subDialog}>
                        <Typography style={{marginBottom: 0}}>{intl.formatMessage({id: "msg_info_group_default_password1"})}</Typography>
                        <Typography>{intl.formatMessage({id: "msg_info_group_default_password2"})}</Typography>
                    </Box>

                    <Box className={classes.inputBox}>
                        <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "msg_info_enter_group_default_password"})} value={defaultPassword} onChange={(e) => setDefaultPassword(e.target.value)}/>
                    </Box>
                    <Box className={classes.groupBtn}>
                        <Button className={clsx(classes.inputButton, classes.inputButtonActive)} disableRipple onClick={handleChangeGroup}>
                            <Typography>{intl.formatMessage({id: "input"})}</Typography>
                        </Button>
                    </Box>
                </>
            }
            {groupStore.dialogType === 'regionApiAddr' &&
                <>
                    <Box className={classes.titleDialog} style={{marginBottom: 10}} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography>{intl.formatMessage({id: "region_api_addr"})}</Typography>
                        <IconButton className={classes.iconButton} onClick={handleClose} disableRipple>
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                    <Box className={classes.subDialog}>
                        <Typography style={{marginBottom: 0}}>{intl.formatMessage({id: "msg_info_group_region_api_addr1"})}</Typography>
                        <Typography>{intl.formatMessage({id: "msg_info_group_region_api_addr2"})}</Typography>
                    </Box>

                    <Box className={classes.inputBox}>
                        <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "msg_info_enter_group_region_api_addr"})} value={regionApiAddr || ''} onChange={(e) => setRegionApiAddr(e.target.value || '')}/>
                    </Box>
                    <Box className={classes.groupBtn}>
                        <Button className={clsx(classes.inputButton, classes.inputButtonActive)} disableRipple onClick={handleChangeGroup}>
                            <Typography>{intl.formatMessage({id: "input"})}</Typography>
                        </Button>
                    </Box>
                </>
            }
        </Dialog>
    );
}

export default inject('groupStore', 'userStore', 'authStore')(injectIntl(observer(GroupDialog)));
